import styled from 'styled-components';
import { theme } from 'styles';
import { WhiteButton } from 'UI';

export const COPY_FEEDBACK_EVENT = 'copyReferenceFeedback:open';

export const SDarkPopupContainer = styled.div`
  position: absolute;
  top: calc(100% + 12px);
  left: -18px;
  z-index: 51;
  background-color: ${theme.color.popup_dark};
  border-radius: 6px;
  padding: 16px 16px 23px;
  width: 438px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.4);

  &::before {
    content: '';
    position: absolute;
    top: -7px; /* triangle height */
    left: 18px; /* 18px from left */
    width: 0;
    height: 0;
    border-left: 8px solid transparent; /* half width */
    border-right: 8px solid transparent; /* half width */
    border-bottom: 8px solid ${theme.color.popup_dark}; /* triangle color */
  }
`;

export const SCloseButton = styled.div`
  position: absolute;
  top: 4px;
  right: 14px;
  color: ${theme.color.white};
  font-size: 36px;
  font-weight: 100;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    opacity: 0.8;
  }
`;

export const SReasonButtonsRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 8px;
  margin-top: 24px;
`;

export const SReasonButton = styled(WhiteButton)`
  width: 100px;
`;

export const SDescription = styled.div`
  margin-top: 8px;
`;

export const SRequestSentIcon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 16px;
`;
